<template>
    <div>
    <h1>客户名称：<span>{{name}}</span></h1>
<!--      <h1>消费记录</h1>-->
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination"  rowKey="id" >
            <span slot="list_order" slot-scope="text, record">
        <a-input placeholder=" " v-model="record.list_order" class="inputs" size="small"/>
            </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    const columns = [
        {
            title: "订单号",
            dataIndex: "order_num",
            ellipsis: true,
            key: "order_num",
            scopedSlots: {customRender: "order_num"}
        },
        {
            title: "交易名称",
            dataIndex: "trade_name",
            ellipsis: true,
            key: "trade_name"
        },
        {
            title: "金额",
            key: "format_order_amount",
            dataIndex: "format_order_amount",
        },{
        title: "支付状态",
        key: "format_pay_status",
        dataIndex: "format_pay_status",  width: "200px",
      },{
        title: "交易详情（元）",
        key: "trade_detail",
        dataIndex: "trade_detail",
      },{
        title: "支付平台交易号",
        key: "pay_id",
        dataIndex: "pay_id",
      },{
        title: "下单时间",
        key: "format_order_time",
        dataIndex: "format_order_time",
      },{
        title: "支付时间",
        key: "format_pay_time",
        dataIndex: "format_pay_time",
      },
    ];
    export default {
        name: 'Finance',
        data() {
            return {
              pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                columns,
              id:this.$route.query.id,
              name:this.$route.query.name
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/OrderList"; //设置左侧导航2-2 active
        },
        methods: {
            getList(page) {
                API.finance.CUSTOMER_ORDERS({page:page||1,a_customer_id:this.id}).then(res => {
                    this.data = res.data.data.list.data
                  this.pagination.total =  res.data.data.list.total
                  this.pagination.pageSize =  res.data.data.list.per_page
                  this.pagination.current =  res.data.data.list.current_page
                    this.loading = false
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    h1{font-size:16px;margin-bottom: 20px}
    h1 span{font-size: 16px}
</style>
